import { useRecoilState } from "recoil";
import OriginalButton from "../components/OriginalButton";
import { selectionAtom } from "../store/selection.atom";

const BreadCrumb = () => {
  const [selection, setSelection] = useRecoilState(selectionAtom);

  return (
    <div className="hidden !h-[69px] border-y-[1px] border-rss-border px-5 py-[10px] md:flex md:items-center md:justify-between md:gap-5">
      <div className="line-clamp-1">
        <span
          onClick={() =>
            setSelection({
              blog: undefined,
              category: undefined,
            })
          }
        >
          Magazines{" "}
        </span>
        <span
          onClick={() =>
            setSelection((prev) => ({
              ...prev,
              blog: undefined,
            }))
          }
        >
          {selection.category && " / " + selection.category.title}
        </span>
        <span>
          {selection.blog !== undefined && " / " + selection.blog.title}
        </span>
      </div>
      {selection.blog !== undefined && <OriginalButton />}
    </div>
  );
};

export default BreadCrumb;
